import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { FaPen, FaPlus, FaRegTrashAlt } from "react-icons/fa";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { CheckPermission } from "../Permissions/CheckPermissions";

const endpoint = `${process.env.REACT_APP_TOKRI_API_URL}/api/home-screen-widgets`;
const protectedWidgetName = (name = "") =>
  ["events", "store deals", "promotions", "from our blog"].some((value) =>
    name.toLowerCase().includes(value),
  );

const HomescreenWidgets = (props) => {
  const [data, setData] = useState([]);
  const [token, setToken] = useState("");
  const [itemForDelete, setItemForDelete] = useState(null);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);

  const getWidgets = (authToken) => {
    fetch(endpoint, { headers: { Authorization: `Bearer ${authToken}` } })
      .then((response) => response.json())
      .then((result) => {
        const widgets = Array.isArray(result) ? result : result?.data || [];
        setData(
          widgets.sort((a, b) => Number(a.sort_order) - Number(b.sort_order)),
        );
      })
      .catch(() => setErrorAlert(true));
  };

  useEffect(() => {
    const authToken = localStorage.getItem("AuthenticationToken");
    setToken(authToken);
    getWidgets(authToken);
  }, []);

  const deleteWidget = () => {
    fetch(`${endpoint}/${itemForDelete.id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setItemForDelete(null);
        if (response.ok || response.status === 202) setSuccessAlert(true);
        else setErrorAlert(true);
      })
      .catch(() => {
        setItemForDelete(null);
        setErrorAlert(true);
      });
  };

  const formatDate = (value) =>
    value ? moment(value).format("DD/MM/YYYY h:mm a") : "Never-ending";
  const isEnabled = (item) =>
    item === true ||
    item === 1 ||
    item === "1" ||
    item === "Y";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs breadcrumbItem="Homescreen Widget" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Button
                  disabled={!CheckPermission("homescreenwidgets", "add")}
                  className="btn btn-success waves-effect waves-light mb-3"
                  onClick={() => props.history.push("/add-homescreen-widget")}
                >
                  <FaPlus size={12} /> Add Homescreen Widget
                </Button>
                <div className="table-responsive">
                  <table className="table table-bordered border-primary mb-0">
                    <thead>
                      <tr>
                        <th>Position</th>
                        <th>Name</th>
                        <th>Published Date</th>
                        <th>Unpublished Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item) => (
                        <tr key={item.id}>
                          <td>{item.sort_order}</td>
                          <td>{item.name}</td>
                          <td>{formatDate(item.published_date)}</td>
                          <td>{formatDate(item.unpublished_date)}</td>
                          <td>
                            <Button
                              color={isEnabled(item.status) ? "success" : "danger"}
                              className={`btn-soft-${isEnabled(item.status) ? "success" : "danger"}`}
                            >
                              {isEnabled(item.status) ? "Enabled" : "Disabled"}
                            </Button></td>
                          <td>
                            <div className="d-flex">
                              {CheckPermission(
                                "homescreenwidgets",
                                "update",
                              ) && (
                                <button
                                  type="button"
                                  className="btn btn-link text-primary p-0 me-3 font-size-18"
                                  onClick={() =>
                                    props.history.push(
                                      "/edit-homescreen-widget",
                                      { item, edit: true },
                                    )
                                  }
                                >
                                  <FaPen />
                                </button>
                              )}
                              {CheckPermission(
                                "homescreenwidgets",
                                "delete",
                              ) && !protectedWidgetName(item.name) && (
                                <Link
                                  to="#"
                                  className="text-danger font-size-18"
                                  onClick={() => setItemForDelete(item)}
                                >
                                  <FaRegTrashAlt />
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {itemForDelete && (
          <SweetAlert
            title="Warning"
            warning
            showCancel
            confirmBtnText="Delete"
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="secondary"
            onConfirm={deleteWidget}
            onCancel={() => setItemForDelete(null)}
          >
            Are you sure you want to delete this Homescreen Widget?
          </SweetAlert>
        )}
        {successAlert && (
          <SweetAlert
            title="Success!"
            success
            confirmBtnBsStyle="success"
            onConfirm={() => {
              setSuccessAlert(false);
              getWidgets(token);
            }}
          >
            Homescreen Widget deleted successfully.
          </SweetAlert>
        )}
        {errorAlert && (
          <SweetAlert
            title="Warning!"
            warning
            confirmBtnBsStyle="warning"
            onConfirm={() => setErrorAlert(false)}
          >
            Error. Something went wrong.
          </SweetAlert>
        )}
      </Container>
    </div>
  );
};

export default HomescreenWidgets;
